import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, renderList as _renderList, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/navbar/miniprog.png'
import _imports_1 from '@/assets/img/navbar/miniprog-active.png'
import _imports_2 from '@/assets/img/navbar/notice.png'
import _imports_3 from '@/assets/img/navbar/notice-active.png'


const _withScopeId = n => (_pushScopeId("data-v-79ac657b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-icon-sort check-icon" }, null, -1))
const _hoisted_3 = { class: "right" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "miniprog-guide" }, "少量的加减保使用手机更方便~", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "miniprog hover" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "icon icon-active",
    src: _imports_1
  }),
  /*#__PURE__*/_createElementVNode("span", null, "小程序版")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "line" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "8",
    cy: "8",
    r: "7.5",
    stroke: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M8 11.5V11",
    stroke: "currentColor",
    "stroke-width": "1.2",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.5 6C6.5 5.17 7.17 4.5 8 4.5C8.83 4.5 9.5 5.17 9.5 6C9.5 6.83 8.83 7.5 8 8V9.5",
    stroke: "currentColor",
    "stroke-width": "1.2",
    "stroke-linecap": "round"
  })
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "操作指引", -1))
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "line" }, null, -1))
const _hoisted_12 = { class: "notice-list" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-top" }, "未读消息", -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 0,
  class: "dot dot-red"
}
const _hoisted_16 = { class: "notice-detail" }
const _hoisted_17 = { class: "notice-head row" }
const _hoisted_18 = { class: "notice-title" }
const _hoisted_19 = { class: "notice-date grey" }
const _hoisted_20 = { class: "notice-content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_2
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon icon-active",
  src: _imports_3
}, null, -1))
const _hoisted_23 = {
  key: 0,
  class: "unNum"
}
const _hoisted_24 = { class: "el-dropdown-link container-user" }
const _hoisted_25 = { class: "user-name" }
const _hoisted_26 = ["src"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "triangle" }, null, -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 账号设置 ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("退出登录 ")
const _hoisted_30 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_switch_client = _resolveComponent("switch-client")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "container-title",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.switchClient && _ctx.switchClient(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.companyName), 1),
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.qrcode)
          ? (_openBlock(), _createBlock(_component_el_popover, {
              key: 0,
              placement: "bottom",
              width: 200,
              trigger: "hover"
            }, {
              reference: _withCtx(() => [
                _hoisted_6
              ]),
              default: _withCtx(() => [
                _createElementVNode("img", {
                  style: {"width":"100%","height":"100%"},
                  src: _ctx.qrcode
                }, null, 8, _hoisted_4),
                _hoisted_5
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_7,
        ( _ctx.helpVideoUrl)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", {
                class: "guide hover",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showGuide = true))
              }, _hoisted_10),
              _hoisted_11
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(_component_el_popover, {
          onShow: _ctx.getMessage,
          placement: "bottom",
          width: 320,
          trigger: "hover"
        }, {
          reference: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ path: '/message' }))),
              class: "notice hover"
            }, [
              _hoisted_21,
              _hoisted_22,
              (_ctx.unReadNum)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.unReadNum), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messageList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "notice-item",
                  key: index
                }, [
                  _createElementVNode("img", {
                    class: "notice-icon",
                    src: item.icon
                  }, null, 8, _hoisted_14),
                  (!item.status)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_19, _toDisplayString(item.create_time), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, _toDisplayString(item.content), 1)
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", {
                class: "notice-bottom link",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ path: '/message' })))
              }, " 更多信息 ")
            ])
          ]),
          _: 1
        }, 8, ["onShow"]),
        _createVNode(_component_el_dropdown, { class: "" }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push({ path:'/user/setting'})))
                }, {
                  default: _withCtx(() => [
                    _hoisted_28
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.exit }, {
                  default: _withCtx(() => [
                    _hoisted_29
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$store.state.userName), 1),
              _createElementVNode("img", {
                class: "user-avatar",
                src: _ctx.$store.state.avatar
              }, null, 8, _hoisted_26),
              _hoisted_27
            ])
          ]),
          _: 1
        })
      ])
    ]),
    (_ctx.isSwitchClientAlert)
      ? (_openBlock(), _createBlock(_component_switch_client, {
          key: 0,
          clientName: _ctx.companyName,
          onClose: _ctx.switchClient
        }, null, 8, ["clientName", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showGuide,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showGuide) = $event)),
      title: "操作指引",
      width: "760px",
      "before-close": _ctx.closeGuide,
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("video", {
          style: {"width":"100%","border-radius":"4px","display":"block"},
          controls: "",
          autoplay: "",
          src: _ctx.helpVideoUrl
        }, null, 8, _hoisted_30)
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ], 64))
}